import { httpClientPrivate } from '@/libs/httpClient'
import { CrashDetectionCase, CrashContactStatus, CrashIncidentStatus } from '../types'
import config from '@/config'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export interface UpdateCrashDetectionDto {
  currentContactStatus?: CrashContactStatus
  currentIncidentStatus?: CrashIncidentStatus
  isSendSurveyor?: boolean
  notifyNumber?: string
  note?: string
}

const updateCrashDetection = async (id: string, data: UpdateCrashDetectionDto) => {
  const { data: responseData } = await httpClientPrivate.post<CrashDetectionCase>(
    `${config.restUrl}/v1/backoffice/crash-detection/${id}`,
    data,
  )
  return responseData
}

const useUpdateCrashDetection = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCrashDetectionDto }) =>
      updateCrashDetection(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['useCrashDetectionList'] })
      queryClient.invalidateQueries({ queryKey: ['useCrashDetectionDetail', variables.id] })
    },
  })

  return { ...mutation }
}

export { updateCrashDetection, useUpdateCrashDetection }
